import React from 'react';
import { DateTime } from 'luxon';
import { Fieldset, Input } from '@flixbus/honeycomb-react';

import { useVoucherFormContext } from '../../../Context';
import { Asterisk } from '../../../Asterisk';
import {
  getNextYear,
  getNextYearDateOnly,
  toISODateEndOfDay,
} from '../../../../../helpers/dateTime';

const VoucherFormValidUntil: React.FC<{ disabled: boolean; busPartner: boolean }> = ({
  disabled,
  busPartner,
}) => {
  const {
    formState: {
      payload: { validSince, validUntil },
    },
    handlePayloadChange,
  } = useVoucherFormContext();

  const dateObject = validUntil ? DateTime.fromISO(validUntil) : null;
  const sinceDate = DateTime.fromISO(validSince);
  const minDate = busPartner
    ? sinceDate.plus({ days: 1 }).toFormat('yyyy-MM-dd')
    : sinceDate.toFormat('yyyy-MM-dd');

  const maxDate = busPartner ? getNextYearDateOnly() : undefined;

  return (
    <Fieldset itemSpacing='half'>
      <Input
        name='date-field-validUntil'
        id='date-field-validUntil'
        label={<>Voucher valid until {!disabled && <Asterisk />}</>}
        type='date'
        min={minDate}
        max={maxDate}
        disabled={disabled}
        required
        info={`The validity ends at 23:59 GMT${DateTime.local().toFormat('ZZ')}`}
        value={dateObject ? dateObject.setLocale('de').toFormat('yyyy-MM-dd') : ''}
        onChange={e => {
          const { value } = e.target;

          if (value === '') {
            handlePayloadChange({
              value: getNextYear(),
              prop: 'validUntil',
            });
          } else {
            const date = new Date(value);
            handlePayloadChange({
              value: toISODateEndOfDay(DateTime.fromJSDate(date)),
              prop: 'validUntil',
            });
          }
        }}
      />
    </Fieldset>
  );
};

export default VoucherFormValidUntil;
